import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase';
import { useTranslation } from 'react-i18next';

export type DescriptionProps = {
  description: string;
  searchPhrase?: string;
};

export const Description = ({ description, searchPhrase }: DescriptionProps) => {
  const { t } = useTranslation();

  if (!description) {
    return null;
  }

  const descriptionTooLong = description.length > 75;
  const displayedDescription = descriptionTooLong ? `${description.slice(0, 75)}...` : description;

  return (
    <Box
      sx={{
        ml: 4,
        display: 'flex',
        flexWrap: 'wrap',
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{
          color: 'text.secondary',
          mr: 0.5,
        }}
      >
        {t('Description:')}{' '}
      </Typography>
      {displayedDescription.split(' ').map((word, index) => (
        <Typography
          variant="body2"
          component="span"
          key={index}
          sx={{
            mr: 0.5,
          }}
        >
          <HighlightedPhrase searchPhrase={searchPhrase}>{word}</HighlightedPhrase>
        </Typography>
      ))}
    </Box>
  );
};
